import partnerJSON from './partner.json'

const DEFAULT_LANG_ID = 'en'

let lang = {}
export default lang
export let langId = DEFAULT_LANG_ID

// Storage access throws instead of returning null in Safari when cookies are
// blocked, so language preference is best effort.
function readStoredLangId() {
	try {
		return localStorage.resqLangId
	} catch {
		return null
	}
}

function storeLangId(id) {
	try {
		localStorage.resqLangId = id
	} catch (e) {
		console.warn('could not store language', e)
	}
}

// Browsers set the language as en-US for example, and we only need the first
// two characters
function supportedLangId(id) {
	if (!id) return null
	const normalized = String(id).substring(0, 2).toLowerCase()
	return partnerJSON.partnerLang[normalized] ? normalized : null
}

export function setLang(id) {
	const navigatorLanguage = window.navigator.userLanguage || window.navigator.language

	const resolvedId =
		supportedLangId(id) ||
		supportedLangId(readStoredLangId()) ||
		supportedLangId(navigatorLanguage) ||
		DEFAULT_LANG_ID

	Object.assign(lang, partnerJSON.partnerLang[resolvedId])
	langId = resolvedId
	storeLangId(resolvedId)
}

export function getLanguageIds() {
	return Object.keys(partnerJSON.partnerLang).sort()
}
